export const ChatConstants = {
    MESSAGE_LIST: "MESSAGE_LIST",
    SEND_MESSAGE:"SEND_MESSAGE"
}